export const InstallmentStatus = {
	0: 'pending',
	1: 'paid',
}